import { Settings } from '@/shared/types/Settings';

import { BASE_URL } from '../constants';
import { getPublic } from '../requestMethods';

const URL = `${BASE_URL}/api/config`;
export const APP_SETTINGS_API = {
  // Get app settings — unauthenticated endpoint used on /auth page
  getAppSettings: () => getPublic<Settings>(`${URL}/settings`),
};
